module.exports = __webpack_public_path__ + "static/images/styles/images/landing/landing-slider-arrows.bbaf148e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing/landing-slider-arrows.png
// module id = 3653
// module chunks = 11